import ABCyaPhaser from "@abcya/abcya_phaser";
import UIAssetKeys from "../UIAssetKeys";
import LocalizationUIAssets from "../Localization-UIAssets";

export const InstructionsEvents = {
  CLOSED: "closed",
};

export default class Instructions extends Phaser.GameObjects.Container {
  constructor(scene, useCloseButton) {
    super(scene);

    this.emitter = new Phaser.Events.EventEmitter();

    this.instructions = ABCyaPhaser.Images.addImage(
      0,
      0,
      LocalizationUIAssets._InstructionsPopup,
      this,
      ABCyaPhaser.Images.LOCALIZATION_ATLAS
    );

    this.actionButton = ABCyaPhaser.Images.addImage(
      0,
      0,
      useCloseButton ? UIAssetKeys._CloseBtn : UIAssetKeys._StartBtn,
      this
    );

    if (!useCloseButton) {
      this.actionButton.scaleX = this.actionButton.scaleY = 0.5;
    }
    this.actionButton.y = 200;

    this.actionButton.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, () => {
      this.emitter.emit(InstructionsEvents.CLOSED);
    });
    this.actionButton.setInteractive({ cursor: "pointer" });
  }
}
